<template>
    <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :class="classes"
    :style="makeStyles(backgroundColor)"
    >
        <title>Close</title>
        <path
            d="M18.3 5.9L12 12m0 0l-6.3 6.1M12 12l6.1 6.3M12 12L5.9 5.7"
            :fill="fill"
            :stroke="stroke"
            stroke-width="2.927"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>

</template>
<script>
export default {
    props: {
        fill: {
            type: String,
            default:"none"
        },
        stroke: {
            type: String,
            default:'#f86262'
        },
        classes: {
            type: String,
            default:"fill-current inline-block h-8 w-8 p-2 rounded-full cursor-pointer bg-background-red"

        },
        backgroundColor: {
            type: String
        }
    }
}
</script>